export const DOCTOR_ASSESSMENT_FORM_TYPES = [
  {
    name: "Basic Assessment",
    formTypeEnum: "BASIC_ASSESSMENT",
  },
  {
    name: "General Assessment",
    formTypeEnum: "GENERAL_ASSESSMENT",
  },
  {
    name: "Extended Assessment",
    formTypeEnum: "EXTENDED_ASSESSMENT",
  },
  {

    name: "qEEG Assessment",
    formTypeEnum: "QEEG_ASSESSMENT",
  },
  {
    name: "LENS NFB Assessment",
    formTypeEnum: "LENS_NFB_ASSESSMENT",
  },
];

export const DOCTOR_STIM_FORM_TYPES = [
  {
    name: "Basic Stim",
    formTypeEnum: "BASIC_STIM",
  },
  {
    name: "General Stim",
    formTypeEnum: "GENERAL_STIM",
  },
  {
    name: "Extended Stim",
    formTypeEnum: "EXTENDED_STIM",
  },
  {
    name: "Virtual Stim",
    formTypeEnum: "VIRTUAL_STIM",
  },
  {
    name: "Virtual ROF: qEEG",
    formTypeEnum: "QEEG_STIM",
  }
];
